<template>
  <section class="vz-personal-data-policy position-relative" ref="$el">
    <vz-checkbox
      small
      v-model="checked"
      :class="{ 'error': isShowError }"
      @click="onChange"
    >
      <template #label>
        <span class="vz-checkbox-label">
          Отправляя данные вы соглашаетесь на обработку <a @click.stop :href="personalDataPolicy" target="_blank">персональных данных</a>
        </span>
      </template>
    </vz-checkbox>
    <vz-invalid-message v-if="isShowError">
      Согласие обязательно
    </vz-invalid-message>
  </section>
</template>

<script setup lang="ts">
import { personalDataPolicy } from '@/api/constant-urls'
import { ValidationRule } from '~/types/types'
import VzCheckbox from "~/components/ui-kit/vz-checkbox.vue";

const emit = defineEmits(['update:modelValue', 'change'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: undefined
  },
  rules: {
    type: Array as PropType<ValidationRule[]>,
    default: () => []
  },
})

const { isShowError, doValidate, dispatchFormEvent } = useValidateble()

const $el = ref()
const checked = ref(props.modelValue)

const onChange = (): void => {
  if (props.disabled) {
    return
  }

  emit('update:modelValue', checked.value)
  emit('change', checked.value)

  nextTick(() => {
    dispatchFormEvent($el.value)
  })
}

async function checkError(silent: boolean = false) {
  return await doValidate(props.modelValue, props.rules, silent)
}

watch(() => props.modelValue,
  () => {
    checked.value = props.modelValue
  }
)

defineExpose({
  checkError, 
  isShowError
})
</script>

<style lang="scss" scoped>
  .vz-personal-data-policy {
    position: relative;
    text-align: left;
    color: $font-low;
    display: flex;
    align-items: center;
    margin: 20px auto;

    :deep(.vz-checkbox) {
      &.error {
        .vz-checkbox-wrapper {
          border-color: $error;
        }
      }

      .vz-checkbox-label {
        font-size: 12px;
        line-height: 14px;
        margin-left: 8px;

        a {
          text-decoration: underline;
        }
      }

      input {
        height: 14px;
      }
    }
  }
</style>
